import React, { useState, useEffect } from 'react';
import "./RelaysCTOne.css";
import RelaysCTTwoUpdate from "./RelaysCTTwoUpdate";
import CreateReport from "./CreateReport";
import { API_URL } from './API';


  const RelayTestForm = ({ block, plant, instrument, project, goBack, reportToUpdate, isUpdateMode }) => {
  const [showNextPage, setShowNextPage] = useState(false);
  const [showBackPage, setShowBackPage] = useState(false);


  const fetchClientName = async (clientId) => {
  try {
    const response = await fetch(`${API_URL}/clients/get_client`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
    });
    
    if (response.ok) {
      const result = await response.json();
      let clientsData = Array.isArray(result) ? result : result.data || result.clients || [];
      const client = clientsData.find(c => c.client_id === clientId || c.id === clientId);
      return client ? client.client_name : "Unknown Client";
    }
  } catch (error) {
    
  }
  return "Unknown Client";
};

  
  const [formData, setFormData] = useState(() => {
   
    if (isUpdateMode && reportToUpdate?.test_data) {
      try {
        let testData = reportToUpdate.test_data;
        if (typeof testData === 'string') {
          testData = JSON.parse(testData);
        }
        const formDataFromReport = testData.formData || testData.a_formData || {};
        
       
        const flatFormData = {};
        Object.keys(formDataFromReport).forEach(key => {
         
          if (typeof formDataFromReport[key] === 'object' && formDataFromReport[key] !== null) {
         
            const values = Object.values(formDataFromReport[key]);
            flatFormData[key] = values.length > 0 ? values[0] : '';
          } else {
            flatFormData[key] = formDataFromReport[key] || '';
          }
        });
        
        
        return flatFormData;
      } catch (error) {
        
      }
    }
    
    const savedData = localStorage.getItem('updateRelayTestData');
    return savedData ? JSON.parse(savedData) : {
      description: '',
      date: '',
      customer: '',
      project: '',
      reportNo: '',
      location: '',
      client: '',
      make: '',
      type: '',
      ctRatio: '',
      supplyVoltage: '',
      serialNo: '',
      vtRatio: ''
    };
  });

  const [rows, setRows] = useState([]);
  const [generalInspection, setGeneralInspection] = useState({});

  

  useEffect(() => {
    if (isUpdateMode && reportToUpdate?.test_data && formData) {
      localStorage.setItem('updateRelayTestData', JSON.stringify(formData));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('updateRelayTestData', JSON.stringify(formData));
  }, [formData]);
  

  
React.useEffect(() => {
  const loadProjectData = async () => {
    if (project) {
      let clientName = project?.clientName || project?.client_name;
      
      if (!clientName && project?.client) {
        clientName = await fetchClientName(project.client);
      }
      
      setFormData(prevData => ({
        ...prevData,
        project: project?.name || '',
        client: clientName || '',
        
      }));
    }
  };
  
  loadProjectData();
}, [project]);

  useEffect(() => {
    const autoSaveInterval = setInterval(() => {
      localStorage.setItem('updateRelayTestData', JSON.stringify(formData));
    }, 5000);

    return () => clearInterval(autoSaveInterval);
  }, [formData]);

  
  const validateInput = (name, value) => {
    switch (name) {
      case 'description':
        return value.replace(/[^a-zA-Z\s/ ]/g, '');

      case 'customer':
      case 'client':
        return value.replace(/[^a-zA-Z\s ]/g, '');


      case 'project':
        
        return value.replace(/[^a-zA-Z0-9, ]/g, '');
      
      case 'reportNo':

        return value.replace(/[^a-zA-Z0-9- ()]/g, '');
      case 'location':
        
        return value.replace(/[^a-zA-Z0-9-, ()]/g, '');
      
      case 'make':
        
        return value.replace(/[^a-zA-Z0-9\s ]/g, '');
      
      case 'type':
      case 'supplyVoltage':
      case 'serialNo':
        
        return value.replace(/[^a-zA-Z0-9/, ]/g, '');
      
      case 'ctRatio':
      case 'vtRatio':
        
        return value.replace(/[^a-zA-Z0-9/ ]/g, '');
      
      default:
        return value;
    }
  };


  
const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    const validatedValue = validateInput(name, value);
    setFormData(prev => ({ ...prev, [name]: validatedValue }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
   
  };

  const handleBack = () => {
    setShowBackPage(true);
    window.location.reload();
  };
  
  const handleNext = (e) => {
    e.preventDefault();
    setShowNextPage(true);
  };

 

  if (showBackPage) {
    return <CreateReport goBack={() => setShowBackPage(false)} savedGeneralFormData={formData} />;
  }

  if (showNextPage) {
    return <RelaysCTTwoUpdate 
      goBack={() => setShowNextPage(false)} 
      savedGeneralData={{
        formData,
        rows,
        generalInspection
      }}
      reportToUpdate={reportToUpdate}
      isUpdateMode={isUpdateMode}
    />;
  }

  return (
    <div>
      <form className="rt-1001" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 className="rt-1002">NUMERICAL RELAY INSPECTION / TEST REPORT(CT/VT)</h2>
        <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '50px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
        </div>
        
        <div className="rt-1003">
          <div className="rt-1004">
            <label className="rt-1005">Description</label>
            <input 
              name="description" 
              value="NUMERICAL RELAY INSPECTION (CT) / TEST REPORT"
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Description' 
              readOnly={"description"}
                  style={"description" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Date</label>
            <input 
              type="date" 
              name="date" 
              value={formData.date || ''} 
              onChange={handleChange} 
              className="rt-1006" 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Customer</label>
            <input 
              name="customer" 
              value={formData.customer || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Customer' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Project</label>
            <input 
              name="project" 
              value={formData.project || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Project' 
              readOnly={"project"}
                  style={"project" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Report No</label>
            <input 
              name="reportNo" 
              value={formData.reportNo || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Report No' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Location</label>
            <input 
              name="location" 
              value={formData.location || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Location' 
             
            />
          </div>
          <div className="rt-1004 rt-1007">
            <label className="rt-1005">Client</label>
            <input 
              name="client" 
              value={formData.client || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Client' 
              readOnly={"client"}
                  style={"client" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
            />
          </div>
        </div>

        <h3 className="rt-1008">NAME PLATE DETAILS</h3>
        <div className="rt-1003">
          <div className="rt-1004">
            <label className="rt-1005">Make</label>
            <input 
              name="make" 
              value={formData.make || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Make' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Type</label>
            <input 
              name="type" 
              value={formData.type || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Type' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">CT Ratio</label>
            <input 
              name="ctRatio" 
              value={formData.ctRatio || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter CT Ratio' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Supply Voltage (Uaux)</label>
            <input 
              name="supplyVoltage" 
              value={formData.supplyVoltage || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Supply Voltage' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Serial No</label>
            <input 
              name="serialNo" 
              value={formData.serialNo || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Serial No' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">VT Ratio</label>
            <input 
              name="vtRatio" 
              value={formData.vtRatio || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='VT Ratio' 
            />
          </div>
        </div>
      
        <div className="button-group">
          <button type="button" onClick={goBack}>Back</button>
          <button type="button" className="nxt1" onClick={handleNext}>Next</button>
        </div>
      </form>
    </div>
  );
};

export default RelayTestForm;